import React from 'react'
import { Controller } from 'react-hook-form'
import { TextField, Grid } from '@material-ui/core'

const BirthDateTextField = ({ input, control, setValue, ...rest }) => {
  return (
    <Grid
      item
      xs={input?.width[0] || 12}
      sm={input?.width[1] || 12}
      md={input?.width[2] || 12}
      lg={input?.width[3] || 12}
      key={input.id}
    >
      <Controller
        name={input?.name}
        control={control}
        as={
          <TextField
            type="date"
            label={input?.labelName}
            variant={input?.field?.variant}
            fullWidth={input?.field?.fullWidth}
            required={input?.field?.required}
            size={input?.field?.size}
            placeholder={input?.field?.placeholder}
            InputLabelProps={{ shrink: true }}
            InputProps={{
              inputProps: {
                min: `${new Date(Date.now()).getFullYear() - 100}-01-01`,
                max: `${new Date(Date.now()).getFullYear() - 18}-${(
                  new Date(Date.now()).getMonth() + 1
                )
                  .toString()
                  .padStart(2, '0')}-${new Date(Date.now())
                  .getDate()
                  .toString()
                  .padStart(2, '0')}`,
              },
            }}
          />
        }
        onChange={(e) => {
          setValue(input.name, e[0]?.target?.value)
          return e[0]?.target?.value
        }}
      />
    </Grid>
  )
}

export default BirthDateTextField
